// Mix recipes (BALTT-529): list recipes with their versions, add a new version, delete the latest unused one.
import axios from "axios";
import settings from "../settings";

let initialState = {
    loadingRecipes: false,
    savingVersion: false,
    requestSuccess: false,
    requestError: false,
    errorMessage: "",
    recipes: [],
};

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async getRecipes({ commit }) {
            commit("setRecipesLoading", true);
            try {
                const response = await axios.get(settings.api_url + "/recipes");
                if (response?.data?.success === 1) {
                    commit("setRecipes", response.data.recipes);
                }
            } catch (e) {
                commit("setError", e.response?.data?.error || "Failed");
            }
            commit("setRecipesLoading", false);
        },
        // Resolves to true when the version was saved so the caller can close its form.
        async createVersion({ commit, dispatch }, { recipeId, validFrom, note, lines }) {
            commit("resetRequestState");
            commit("setSavingVersion", true);
            let saved = false;
            try {
                const response = await axios.post(`${settings.api_url}/recipes/${recipeId}/versions`, {
                    valid_from: validFrom,
                    note: note,
                    lines: lines,
                });
                if (response?.data?.success === 1) {
                    saved = true;
                    commit("setRequestSuccess", true);
                    await dispatch("getRecipes");
                }
            } catch (e) {
                commit("setError", e.response?.data?.error || "Failed");
            }
            commit("setSavingVersion", false);
            return saved;
        },
        async deleteVersion({ commit, dispatch }, versionId) {
            commit("resetRequestState");
            commit("setRecipesLoading", true);
            try {
                const response = await axios.delete(`${settings.api_url}/recipe-versions/${versionId}`);
                if (response?.data?.success === 1) {
                    commit("setRequestSuccess", true);
                    await dispatch("getRecipes");
                }
            } catch (e) {
                commit("setError", e.response?.data?.error || "Failed");
            }
            commit("setRecipesLoading", false);
        },
    },
    mutations: {
        setRecipes(state, recipes) {
            state.recipes = recipes;
        },
        setRecipesLoading(state, value) {
            state.loadingRecipes = value;
        },
        setSavingVersion(state, value) {
            state.savingVersion = value;
        },
        setRequestSuccess(state, value) {
            state.requestSuccess = value;
        },
        setError(state, message) {
            state.requestError = true;
            state.errorMessage = message;
        },
        resetRequestState(state) {
            state.requestSuccess = false;
            state.requestError = false;
            state.errorMessage = "";
        },
    },
};
